import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import PageLayout from "@/components/layout/pageLayout/PageLayout";
import Header from "@/components/layout/header/Header";
import headerStyles from "@/components/layout/header/Header.module.css";
import styles from "./Login.module.css";
import LoginForm from "./LoginForm";

const BENEFITS = [
    "Simulacros tipo Saber 11 / ICFES",
    "Resultados y percentiles al instante",
    "Seguimiento de tu progreso",
];

const Login: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        document.body.classList.add("solid-public-bg");
        return () => document.body.classList.remove("solid-public-bg");
    }, []);

    return (
        <PageLayout
            header={
                <Header
                    variant="default"
                    rightContent={
                        <div className={headerStyles.links}>
                            <button
                                onClick={() => navigate("/social-contact")}
                                className={`${headerStyles.link} ${headerStyles.button}`}
                            >
                                CONTACTO
                            </button>
                            <button
                                onClick={() => navigate("/login")}
                                className={`${headerStyles.link} ${headerStyles.button}`}
                            >
                                INGRESO
                            </button>
                        </div>
                    }
                />
            }
            main={
                <div className={styles.split}>
                    <aside className={styles.brand}>
                        <span className={styles["brand-kicker"]}>EDUDATA</span>
                        <h2 className={styles["brand-title"]}>
                            Bienvenido de nuevo
                        </h2>
                        <p className={styles["brand-text"]}>
                            Accede a tus simulacros y revisa tus resultados, percentiles y
                            tu progreso académico.
                        </p>
                        <ul className={styles["brand-list"]}>
                            {BENEFITS.map((b) => (
                                <li key={b} className={styles["brand-item"]}>
                                    <CheckCircle2 size={18} />
                                    <span>{b}</span>
                                </li>
                            ))}
                        </ul>
                    </aside>

                    <div className={styles["form-side"]}>
                        <LoginForm />
                    </div>
                </div>
            }
            footer={null}
        />
    );
};

export default Login;
